(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };
},{"core-js/library/fn/array/from":13}],2:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };
},{"core-js/library/fn/object/assign":14}],3:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };
},{"core-js/library/fn/object/keys":15}],4:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };
},{"core-js/library/fn/promise":16}],5:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };
},{"core-js/library/fn/symbol":17}],6:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };
},{"core-js/library/fn/symbol/iterator":18}],7:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _promise = require("../core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};
},{"../core-js/promise":4}],8:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _assign = require("../core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
},{"../core-js/object/assign":2}],9:[function(require,module,exports){
"use strict";

exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};
},{}],10:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _from = require("../core-js/array/from");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};
},{"../core-js/array/from":1}],11:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _iterator = require("../core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("../core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
},{"../core-js/symbol":5,"../core-js/symbol/iterator":6}],12:[function(require,module,exports){
module.exports = require("regenerator-runtime");

},{"regenerator-runtime":107}],13:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;

},{"../../modules/_core":26,"../../modules/es6.array.from":94,"../../modules/es6.string.iterator":100}],14:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;

},{"../../modules/_core":26,"../../modules/es6.object.assign":96}],15:[function(require,module,exports){
require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;

},{"../../modules/_core":26,"../../modules/es6.object.keys":97}],16:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
require('../modules/es7.promise.finally');
require('../modules/es7.promise.try');
module.exports = require('../modules/_core').Promise;

},{"../modules/_core":26,"../modules/es6.object.to-string":98,"../modules/es6.promise":99,"../modules/es6.string.iterator":100,"../modules/es7.promise.finally":102,"../modules/es7.promise.try":103,"../modules/web.dom.iterable":106}],17:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;

},{"../../modules/_core":26,"../../modules/es6.object.to-string":98,"../../modules/es6.symbol":101,"../../modules/es7.symbol.async-iterator":104,"../../modules/es7.symbol.observable":105}],18:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');

},{"../../modules/_wks-ext":91,"../../modules/es6.string.iterator":100,"../../modules/web.dom.iterable":106}],19:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],20:[function(require,module,exports){
module.exports = function () { /* empty */ };

},{}],21:[function(require,module,exports){
module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

},{}],22:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":46}],23:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":82,"./_to-iobject":84,"./_to-length":85}],24:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":25,"./_wks":92}],25:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],26:[function(require,module,exports){
var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],27:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":59,"./_property-desc":72}],28:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":19}],29:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],30:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":35}],31:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":37,"./_is-object":46}],32:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],33:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":64,"./_object-keys":67,"./_object-pie":68}],34:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var ctx = require('./_ctx');
var hide = require('./_hide');
var has = require('./_has');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":26,"./_ctx":28,"./_global":37,"./_has":38,"./_hide":39}],35:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],36:[function(require,module,exports){
var ctx = require('./_ctx');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var anObject = require('./_an-object');
var toLength = require('./_to-length');
var getIterFn = require('./core.get-iterator-method');
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

},{"./_an-object":22,"./_ctx":28,"./_is-array-iter":44,"./_iter-call":47,"./_to-length":85,"./core.get-iterator-method":93}],37:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],38:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],39:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":30,"./_object-dp":59,"./_property-desc":72}],40:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":37}],41:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":30,"./_dom-create":31,"./_fails":35}],42:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

},{}],43:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":25}],44:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":52,"./_wks":92}],45:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":25}],46:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],47:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":22}],48:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":39,"./_object-create":58,"./_property-desc":72,"./_set-to-string-tag":76,"./_wks":92}],49:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":34,"./_hide":39,"./_iter-create":48,"./_iterators":52,"./_library":53,"./_object-gpo":65,"./_redefine":74,"./_set-to-string-tag":76,"./_wks":92}],50:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":92}],51:[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],52:[function(require,module,exports){
module.exports = {};

},{}],53:[function(require,module,exports){
module.exports = true;

},{}],54:[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":35,"./_has":38,"./_is-object":46,"./_object-dp":59,"./_uid":88}],55:[function(require,module,exports){
var global = require('./_global');
var macrotask = require('./_task').set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = require('./_cof')(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

},{"./_cof":25,"./_global":37,"./_task":81}],56:[function(require,module,exports){
'use strict';
// 25.4.1.5 NewPromiseCapability(C)
var aFunction = require('./_a-function');

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"./_a-function":19}],57:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;

},{"./_fails":35,"./_iobject":43,"./_object-gops":64,"./_object-keys":67,"./_object-pie":68,"./_to-object":86}],58:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":22,"./_dom-create":31,"./_enum-bug-keys":32,"./_html":40,"./_object-dps":60,"./_shared-key":77}],59:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":22,"./_descriptors":30,"./_ie8-dom-define":41,"./_to-primitive":87}],60:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":22,"./_descriptors":30,"./_object-dp":59,"./_object-keys":67}],61:[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":30,"./_has":38,"./_ie8-dom-define":41,"./_object-pie":68,"./_property-desc":72,"./_to-iobject":84,"./_to-primitive":87}],62:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":63,"./_to-iobject":84}],63:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":32,"./_object-keys-internal":66}],64:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],65:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":38,"./_shared-key":77,"./_to-object":86}],66:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":23,"./_has":38,"./_shared-key":77,"./_to-iobject":84}],67:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":32,"./_object-keys-internal":66}],68:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],69:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export');
var core = require('./_core');
var fails = require('./_fails');
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};

},{"./_core":26,"./_export":34,"./_fails":35}],70:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

},{}],71:[function(require,module,exports){
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var newPromiseCapability = require('./_new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"./_an-object":22,"./_is-object":46,"./_new-promise-capability":56}],72:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],73:[function(require,module,exports){
var hide = require('./_hide');
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

},{"./_hide":39}],74:[function(require,module,exports){
module.exports = require('./_hide');

},{"./_hide":39}],75:[function(require,module,exports){
'use strict';
var global = require('./_global');
var core = require('./_core');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_core":26,"./_descriptors":30,"./_global":37,"./_object-dp":59,"./_wks":92}],76:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":38,"./_object-dp":59,"./_wks":92}],77:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":78,"./_uid":88}],78:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":26,"./_global":37,"./_library":53}],79:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var SPECIES = require('./_wks')('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

},{"./_a-function":19,"./_an-object":22,"./_wks":92}],80:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":29,"./_to-integer":83}],81:[function(require,module,exports){
var ctx = require('./_ctx');
var invoke = require('./_invoke');
var html = require('./_html');
var cel = require('./_dom-create');
var global = require('./_global');
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (require('./_cof')(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

},{"./_cof":25,"./_ctx":28,"./_dom-create":31,"./_global":37,"./_html":40,"./_invoke":42}],82:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":83}],83:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],84:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":29,"./_iobject":43}],85:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":83}],86:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":29}],87:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":46}],88:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],89:[function(require,module,exports){
var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

},{"./_global":37}],90:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":26,"./_global":37,"./_library":53,"./_object-dp":59,"./_wks-ext":91}],91:[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":92}],92:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":37,"./_shared":78,"./_uid":88}],93:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":24,"./_core":26,"./_iterators":52,"./_wks":92}],94:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":27,"./_ctx":28,"./_export":34,"./_is-array-iter":44,"./_iter-call":47,"./_iter-detect":50,"./_to-length":85,"./_to-object":86,"./core.get-iterator-method":93}],95:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":20,"./_iter-define":49,"./_iter-step":51,"./_iterators":52,"./_to-iobject":84}],96:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":34,"./_object-assign":57}],97:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object');
var $keys = require('./_object-keys');

require('./_object-sap')('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

},{"./_object-keys":67,"./_object-sap":69,"./_to-object":86}],98:[function(require,module,exports){

},{}],99:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var global = require('./_global');
var ctx = require('./_ctx');
var classof = require('./_classof');
var $export = require('./_export');
var isObject = require('./_is-object');
var aFunction = require('./_a-function');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var speciesConstructor = require('./_species-constructor');
var task = require('./_task').set;
var microtask = require('./_microtask')();
var newPromiseCapabilityModule = require('./_new-promise-capability');
var perform = require('./_perform');
var userAgent = require('./_user-agent');
var promiseResolve = require('./_promise-resolve');
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

},{"./_a-function":19,"./_an-instance":21,"./_classof":24,"./_core":26,"./_ctx":28,"./_export":34,"./_for-of":36,"./_global":37,"./_is-object":46,"./_iter-detect":50,"./_library":53,"./_microtask":55,"./_new-promise-capability":56,"./_perform":70,"./_promise-resolve":71,"./_redefine-all":73,"./_set-species":75,"./_set-to-string-tag":76,"./_species-constructor":79,"./_task":81,"./_user-agent":89,"./_wks":92}],100:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":49,"./_string-at":80}],101:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  require('./_object-gops').f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":22,"./_descriptors":30,"./_enum-keys":33,"./_export":34,"./_fails":35,"./_global":37,"./_has":38,"./_hide":39,"./_is-array":45,"./_is-object":46,"./_library":53,"./_meta":54,"./_object-create":58,"./_object-dp":59,"./_object-gopd":61,"./_object-gopn":63,"./_object-gopn-ext":62,"./_object-gops":64,"./_object-keys":67,"./_object-pie":68,"./_property-desc":72,"./_redefine":74,"./_set-to-string-tag":76,"./_shared":78,"./_to-iobject":84,"./_to-primitive":87,"./_uid":88,"./_wks":92,"./_wks-define":90,"./_wks-ext":91}],102:[function(require,module,exports){
// https://github.com/tc39/proposal-promise-finally
'use strict';
var $export = require('./_export');
var core = require('./_core');
var global = require('./_global');
var speciesConstructor = require('./_species-constructor');
var promiseResolve = require('./_promise-resolve');

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

},{"./_core":26,"./_export":34,"./_global":37,"./_promise-resolve":71,"./_species-constructor":79}],103:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-promise-try
var $export = require('./_export');
var newPromiseCapability = require('./_new-promise-capability');
var perform = require('./_perform');

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

},{"./_export":34,"./_new-promise-capability":56,"./_perform":70}],104:[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":90}],105:[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":90}],106:[function(require,module,exports){
require('./es6.array.iterator');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var TO_STRING_TAG = require('./_wks')('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

},{"./_global":37,"./_hide":39,"./_iterators":52,"./_wks":92,"./es6.array.iterator":95}],107:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = require("./runtime");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

},{"./runtime":108}],108:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);

},{}],109:[function(require,module,exports){
'use strict';

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.component('multi-select', window.VueMultiselect.default);

Vue.component('extension-modal', {
    template: '#extensionModal',
    data: function data() {
        return {
            curItineraryIndex: 0
        };
    },

    props: {
        product: {
            type: Object,
            default: {}
        }

    },
    computed: {
        currentItinerary: function currentItinerary() {
            var _this = this;

            if (Array.isArray(this.product.product_itineraries)) {
                if (this.curItineraryIndex >= 0 && this.curItineraryIndex < this.product.product_itineraries.length) return this.product.product_itineraries.find(function (it, i) {
                    return i === _this.curItineraryIndex;
                });
            }
            return {};
        }
    },
    methods: {
        compiledItineraries: function compiledItineraries(it) {
            if (it) {
                return it.replace(/\[Bus\]/g, "<i class='fas fa-bus'></i>").replace(/\[Plane\]/g, "<i class='fas fa-plane'></i>").replace(/\[Train\]/g, "<i class='fas fa-train'></i>").replace(/\[Ship\]/g, "<i class='fas fa-ship'></i>");
            }
            return '';
        }
    }
});

Vue.component('card-form', {
    template: '#cardForm',
    props: {
        paymentMethod: {
            type: Number,
            required: true,
            default: function _default() {
                return undefined.paymentMethods.stripe;
            }

        },
        cardNo: {
            type: Object,
            required: true,
            default: null
        },
        exp: {
            type: Object,
            required: true,
            default: null

        },
        cvc: {
            type: Object,
            required: true,
            default: null

        },
        cardName: {
            type: String,
            default: null

        },
        stripeInstance: {
            type: Object,
            required: true
        }
    },
    computed: {
        requireCardName: function requireCardName() {
            return this.paymentMethod === this.paymentMethods.stripe ? 'required' : '';
        }
    },
    mounted: function mounted() {
        this.$emit('mount-elements', true);
    }
});

Vue.use(VeeValidate);
var vm = new Vue({
    data: function data() {
        return (0, _extends3.default)({}, serverData);
    },
    el: '#bookingForm',
    created: function created() {
        this.paymentMethod = this.paymentMethods.stripe;
        this.selectedTab = this.firstStep;
        this.booking = this.initBookingState();
        if (this.getComputedDeposit(this.product, 1)) {
            this.action = actionTypes.deposit;
        } else {
            this.action = actionTypes.fullyPaid;
        }
        if ((0, _typeof3.default)(this.user) === 'object' && Array.isArray(this.user) && this.user.length === 0) {
            this.user = {
                first_name: '',
                last_name: '',
                email: ''
            };
        }
        this.initPaypalInstance();
        this.initStripeInstance();
        this.reloadProductExtensionWithDate(this.booking.departure_date);
        // let that = this;
        // $.each(this.rooms_max, function (key, value) {
        //     that.object_set(that.rooms_max, key + ".qty_max", Math.ceil(that.paxNum / value["max"]));
        // });
    },
    mounted: function mounted() {
        var _this2 = this;

        this.initPlugins();
        this.startLogInfoTimer();
        window.dataLayer = window.dataLayer || [];
        $("body").on("click", function (e) {
            _this2.showCalendar = false;
        });
        $("div.show-calendar").on("click", function (t) {
            t.stopPropagation();
        });
        $("#travelDatePicker").on("click", function (t) {
            t.stopPropagation();
        });

        //this.$on('update-room-no',this.manipulateRoomNo);
    },

    watch: {
        'booking.departure_date': function bookingDeparture_date(val) {
            var addtl = { departure_date: val };
            this.postBookingIntention(addtl);
        },
        'booking.departure_city': function bookingDeparture_city(val) {
            var addtl = { departure_city: val };
            this.postBookingIntention(addtl);
        },
        'booking.number_of_pax': function bookingNumber_of_pax(val) {
            var addtl = { number_of_pax: val };
            this.postBookingIntention(addtl);
        }
    },
    computed: {
        productSalesPrice: function productSalesPrice() {
            return this.product.sales_price;
        },
        paxNum: function paxNum() {
            return this.booking.number_of_pax || 0;
        },
        totalPaidAmt: function totalPaidAmt() {
            var price = Number(this.pricePerPerson) + Number(this.seasonalCharge);
            if (this.deCityCharge) {
                price += Number(this.deCityCharge);
            }
            //                    if(this.object_get(this.booking,'rooms.single')>0 && this.roomSingleSupplement >0)
            //                    {
            //                        singleRoomPrice= Number(this.object_get(this.booking,'rooms.single') * this.roomSingleSupplement);
            //                    }
            if (Array.isArray(this.selectedExtensions)) {
                price += this.selectedExtensions.reduce(function (carry, ex) {
                    carry += ex.land_only_price || 0;
                    return carry;
                }, 0);
            }

            return price * this.paxNum + this.roomSingleSupplement - this.appliedDiscount - this.agentCommissionDeduction;
        },
        totalDepositAmt: function totalDepositAmt() {
            var _this3 = this;

            //               let deposit = this.product.deposit;
            var deposit = (this.product.allow_deposit ? this.getComputedDeposit(this.product, 1) : this.product.regular_price) || 0;
            if (Array.isArray(this.selectedExtensions)) {
                deposit += this.selectedExtensions.reduce(function (carry, ex) {
                    carry += ex.allow_deposit ? _this3.getComputedDeposit(ex, 0) : ex.land_only_price || 0;
                    return carry;
                }, 0);
            }

            return this.paxNum * deposit;
        },
        shouldDeposit: function shouldDeposit() {
            var shouldDep = this.product.allow_deposit;
            var extShouldDep = false;
            if (Array.isArray(this.selectedExtensions)) {
                extShouldDep = this.selectedExtensions.reduce(function (carry, ex) {
                    return ex.allow_deposit || carry;
                }, extShouldDep);
            }
            return shouldDep || extShouldDep;
        },
        pricePerPerson: function pricePerPerson() {
            return this.productSalesPrice || this.product.regular_price || 0;
        },
        deCityCharge: function deCityCharge() {
            if (this.bookingDepartureCityEntity) return this.object_get(this.bookingDepartureCityEntity, 'pivot.surcharge') || 0;

            return 0;
        },
        seasonalCharge: function seasonalCharge() {
            var _this4 = this;

            var seasonal = 0;
            if (this.bookingDepartureDateEntity) {
                seasonal = this.bookingDepartureDateEntity.surcharge;
            }
            if (Array.isArray(this.selectedExtensions)) {
                seasonal += this.selectedExtensions.reduce(function (carry, ex) {
                    carry += _this4.object_get(ex, 'departure_dates.0.surcharge', 0);
                    return carry;
                }, 0);
            }
            return seasonal;
        },
        appliedDiscount: function appliedDiscount() {
            var _this5 = this;

            return this.includedVouchers.reduce(function (carry, voucher) {
                var price = _this5.product.regular_price;
                var discount = voucher.discount;
                if (discount < 1) {
                    discount = price * discount;
                }
                discount = Math.round(discount);

                // if(voucher.type == {{\App\Models\Operation\ProductPromotion::T_PASSENGER}}){
                if (voucher.type == _this5.promotionTypes.passenger) {
                    carry += discount * _this5.paxNum;
                } else {
                    carry += discount;
                }
                return carry;
            }, 0);
        },
        validDates: function validDates() {
            if (this.isNotEmptyArray(this.product.departure_dates)) return this.product.departure_dates;
            return [];
        },
        bookingDepartureDateEntity: function bookingDepartureDateEntity() {
            var _this6 = this;

            if (this.booking.departure_date) return this.validDates.find(function (date) {
                return date.departure_date === _this6.booking.departure_date;
            });
            return null;
        },
        bookingDepartureCityEntity: function bookingDepartureCityEntity() {
            var _this7 = this;

            if (this.booking.departure_city && this.isNotEmptyArray(this.product.departure_cities)) return this.product.departure_cities.find(function (c) {
                return c.name === _this7.booking.departure_city;
            });
            return null;
        },
        startDate: function startDate() {
            var startDate = this.validDates.find(function (date, i) {
                return i === 0;
            });
            if (startDate) {
                var startMoment = moment(startDate.departure_date);
                var month = startMoment.month();
                var year = startMoment.year();
                var day = 1;
                return moment([year, month, day]).format(this.dateFormats.yearToDay);
            }
            return '';
        },
        strProdStartDate: function strProdStartDate() {
            if (this.booking.departure_date) return this.formattedDate(this.getMomentObject(this.booking.departure_date), this.dateFormats.dayToYear);

            return '';
        },
        strProdEndDate: function strProdEndDate() {
            if (this.booking.departure_date) return this.formattedDate(this.endDate(this.booking.departure_date, this.product.length), this.dateFormats.dayToYear);

            return '';
        },
        lastStep: function lastStep() {
            var tabsKeysArr = (0, _keys2.default)(this.tabs);
            return this.tabs[tabsKeysArr[tabsKeysArr.length - 1]];
        },
        firstStep: function firstStep() {
            var tabsKeysArr = (0, _keys2.default)(this.tabs);
            return this.tabs[tabsKeysArr[0]];
        },
        roomSingleSupplement: function roomSingleSupplement() {
            var total = 0;
            // let singleRoomNo = this.object_get(this.booking, 'rooms.single', 0);
            // if (singleRoomNo > 0) {
            //     total = this.product.single_supplement;
            //     if (Array.isArray(this.extensions)) {
            //         total += this.extensions.reduce((carry, ex) => {
            //             carry += ex.single_supplement || 0;
            //             return carry;
            //         }, 0);
            //     }
            //     total = total * singleRoomNo;
            // }
            if (this.paxNum === 1) {
                total += this.productArray.reduce(function (carry, item) {
                    return carry += item.single_supplement || 0;
                }, total);
            }

            return total;
        },
        invoiceDescription: function invoiceDescription() {
            var str = this.product.name + ' -' + this.booking.departure_date;
            str += ' payment: ' + this.product.regular_price + ' p.p ';
            if (this.action === this.actionTypes.deposit) {
                str += '- Deposit ' + this.getComputedDeposit(this.product, 1) + ' p.p' + ('= ' + (this.product.regular_price - this.getComputedDeposit(this.product, 1)));
            }

            return str;
        },
        productArray: function productArray() {
            var _this8 = this;

            var list = [(0, _extends3.default)({}, this.product, { isCore: 1 })];
            var commissions = this.object_get(this.user, 'agent.commissions', {});

            if (Array.isArray(this.selectedExtensions) && this.selectedExtensions.length > 0) {
                list = [].concat((0, _toConsumableArray3.default)(list), (0, _toConsumableArray3.default)(this.selectedExtensions));
                list.sort(function (a, b) {
                    var aSubjectDate = a.isCore ? _this8.bookingDepartureDateEntity.departure_date : _this8.getProduct(a, 'departure_dates', 'departure_date'),
                        bSubjectDate = b.isCore ? _this8.bookingDepartureDateEntity.departure_date : _this8.getProduct(b, 'departure_dates', 'departure_date');
                    var aMoment = moment(aSubjectDate);
                    if (aMoment.isBefore(bSubjectDate)) return -1;else if (aMoment.isAfter(bSubjectDate)) return 1;else return 0;
                });
            }

            return list.map(function (item, i) {
                var it = (0, _extends3.default)({}, item);
                if (_this8.isAgent) {
                    it['type_commission_rate'] = commissions[(it.is_on_promo ? 'p' : '') + it.product_type] || 0.1;
                }
                var subjectDate = null;
                if (item.isCore) {
                    subjectDate = _this8.object_get(_this8.bookingDepartureDateEntity, 'departure_date');
                } else {
                    subjectDate = _this8.getProduct(item, 'departure_dates', 'departure_date');
                }

                // if (Array.isArray(this.selectedExtensions) && this.selectedExtensions.length > 0) {
                if (subjectDate) {
                    if (i !== 0) {
                        var display_departure_date = _this8.formattedDate(moment(subjectDate).add(_this8.object_get(item, 'pre_overnight'), 'days'), _this8.dateFormats.dayToYearHuman);
                        it['display_departure_date'] = display_departure_date;
                    } else {
                        it['display_departure_date'] = _this8.formattedDate(moment(subjectDate), _this8.dateFormats.dayToYearHuman);
                    }
                    if (i !== list.length - 1) {
                        var display_end_date = _this8.formattedDate(_this8.endDate(subjectDate, item.length - item.post_overnight), _this8.dateFormats.dayToYearHuman);
                        it['display_end_date'] = display_end_date;
                    } else {
                        it['display_end_date'] = _this8.formattedDate(_this8.endDate(subjectDate, item.length), _this8.dateFormats.dayToYearHuman);
                    }
                }

                // }
                it['sum_up_price'] = (it.isCore ? it.regular_price : it.land_only_price) * _this8.paxNum;
                return it;
            });
        },
        strDateDuration: function strDateDuration() {
            var datesArray = [],
                firstIndex = 0;
            var startDate = this.formattedDate(moment(this.getProduct(this.productArray[firstIndex], 'departure_dates', 'departure_date')), this.dateFormats.dayToYearHuman);
            datesArray.push(startDate);
            var lastProduct = this.productArray[this.productArray.length - 1];
            var endDate = this.formattedDate(this.endDate(this.getProduct(lastProduct, 'departure_dates', 'departure_date'), this.getProduct(lastProduct, 'length')), this.dateFormats.dayToYearHuman);
            datesArray.push(endDate);
            return datesArray.join(' - ');
        },
        hasExtensions: function hasExtensions() {
            var _this9 = this;

            if (Array.isArray(this.extensions) && this.extensions.length > 0) {
                if (this.booking.departure_date) {
                    return this.extensions.some(function (ex) {
                        return moment(_this9.booking.departure_date).isSame(_this9.object_get(ex, 'pivot.departure_date') || '');
                    });
                }
            }
            return false;
        },
        selectedExtensions: function selectedExtensions() {
            var arr = [];
            if (this.preExtensionId) {
                arr.push((0, _extends3.default)({}, this.preExtension));
            }
            if (this.postExtensionId) {
                arr.push((0, _extends3.default)({}, this.postExtension));
            }
            if (arr.length) return arr;else return null;
        },
        preExtension: function preExtension() {
            var _this10 = this;

            if (this.preExtensionId) {
                return this.extensionProducts(this.extensionTypes.pre).find(function (p) {
                    return p.pivot.extended_product_id === _this10.preExtensionId;
                });
            }
            return null;
        },
        preExtensionDate: function preExtensionDate() {
            if (this.preExtension) {
                var pre = this.preExtension;
                var date = moment(this.booking.departure_date).add(this.product.pre_overnight - pre.length + pre.post_overnight, 'days');

                return date.format('DD/MM/YYYY');
            }

            return '';
        },
        postExtension: function postExtension() {
            var _this11 = this;

            if (this.postExtensionId) {
                //                    return  this.extensions.find(p => (p.pivot.extended_product_id === this.postExtensionId ));
                return this.extensionProducts(this.extensionTypes.post).find(function (p) {
                    return p.pivot.extended_product_id === _this11.postExtensionId;
                });
            }
            return null;
        },
        postExtensionDate: function postExtensionDate() {
            if (this.postExtension) {
                var post = this.postExtension;
                var date = moment(this.booking.departure_date).add(this.product.length - this.product.post_overnight - post.pre_overnight, 'days');
                //                        this.postExtension =  {}
                return date.format('DD/MM/YYYY');
            }
            return '';
        },
        agentCommissionDeduction: function agentCommissionDeduction() {
            if (this.isAgent) {
                return this.productArray.reduce(function (carry, prod) {
                    if (prod.type_commission_rate > 1) {
                        return carry += prod.type_commission_rate;
                    } else {
                        if (prod.isCore) carry += Number(prod.regular_price * prod.type_commission_rate);else carry += Number(prod.land_only_price * prod.type_commission_rate);
                    }

                    return Math.round(carry);
                }, 0) * this.paxNum;
            }
            return 0;
        }
    },
    methods: {
        login: function login() {
            var _this12 = this;

            var data = {
                password: this.userPassword,
                username: this.user.email,
                flash_login: 1
            };
            $.post('/login', data, function () {}).then(function (data) {
                //console.log(data);
                if (!data.success) {
                    noty({ layout: 'center', type: data.success ? 'success' : 'error', text: data.msg });
                } else {
                    _this12.hasLogin = true;
                    if ((0, _typeof3.default)(data.user) === 'object') _this12.user = data.user;
                }
            });
        },
        resetPassword: function resetPassword() {
            var _this13 = this;

            if (!this.user.id) noty({ layout: 'center', type: 'error', text: 'cant locate user id ' });else if (!this.user.reset_pwd_code) {
                noty({ layout: 'center', type: 'error', text: 'cant find the code' });
            } else if (!this.user.activation_code) {
                noty({ layout: 'center', type: 'error', text: 'cant find the activation code' });
            } else {
                var data = {
                    id: this.user.id,
                    password: this.userPassword,
                    code: this.user.reset_pwd_code,
                    activation_code: this.user.activation_code,
                    flash_login: 1
                };
                // $.post("{{route('change_password')}}",data).then((data)=>{
                $.post("/change-password", data).then(function (data) {

                    if (data.error) {
                        noty({ layout: 'center', type: data.error ? 'error' : 'success', text: data.msg });
                    } else {
                        _this13.hasLogin = true;
                        if ((0, _typeof3.default)(data.user) === 'object') _this13.user = data.user;
                    }
                });
            }
        },
        sendCode: function sendCode() {
            var data = { email: this.user.email };
            $.post('/account/send-code', data, function () {}).then(function (data) {
                noty({ layout: 'center', type: data.success ? 'success' : 'error', text: data.msg });
            });
        },
        validateCode: function validateCode() {
            var _this14 = this;

            var data = { email: this.user.email, code: this.code };
            $.post('/account/validate-code', data, function () {}).then(function (data) {
                //noty({layout:'center',type:data.success?'success':'error',text:data.msg});
                if (data.success) {
                    _this14.user = data.user;
                } else {
                    noty({ layout: 'center', type: 'error', text: data.msg });
                }
            });
        },
        checkBookingOpt: function checkBookingOpt() {
            if (this.selectedBookingOpt === this.bookingOpt.bookForSelf) {
                var userInfo = (0, _extends3.default)({}, this.user);
                var leadFirstName = 'passengers.' + this.leadIndex + '.first_name',
                    leadSurname = 'passengers.' + this.leadIndex + '.surname';
                this.object_set(this.booking, leadFirstName, userInfo.first_name);
                this.object_set(this.booking, leadSurname, userInfo.last_name);
            } else {
                this.object_set(this.booking, 'passengers.' + this.leadIndex + '.first_name', '');
                this.object_set(this.booking, 'passengers.' + this.leadIndex + '.surname', '');
            }
        },
        goNextTab: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var _this15 = this;

                var fieldsMap, hasError, reversedDict, msg, promiseArray, promiseResult;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                fieldsMap = this.tabFieldsCollection();
                                hasError = false;
                                reversedDict = this.reversedKeyValDict(this.tabs);
                                msg = '';

                                if (!((0, _typeof3.default)(fieldsMap[reversedDict[this.selectedTab]]) === 'object' && Array.isArray(fieldsMap[reversedDict[this.selectedTab]]) && fieldsMap[reversedDict[this.selectedTab]].length > 0)) {
                                    _context.next = 11;
                                    break;
                                }

                                promiseArray = fieldsMap[reversedDict[this.selectedTab]].map(function (field) {
                                    return _this15.$validator.validate(field);
                                });
                                _context.next = 8;
                                return _promise2.default.all(promiseArray);

                            case 8:
                                promiseResult = _context.sent;

                                if (promiseResult) {
                                    hasError = promiseResult.some(function (result) {
                                        return result === false;
                                    });
                                }

                                msg = "Required fields can not be empty";

                            case 11:

                                if (!hasError) {
                                    this.selectedTab++;
                                    this.scrollTop();
                                } else {
                                    noty({
                                        text: msg,
                                        layout: 'center',
                                        type: "error"
                                    });
                                }

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function goNextTab() {
                return _ref.apply(this, arguments);
            }

            return goNextTab;
        }(),
        goLastTab: function goLastTab() {
            this.selectedTab--;
            this.scrollTop();
        },
        scrollTop: function scrollTop() {
            this.$nextTick(function () {
                $('body,html').stop().animate({
                    scrollTop: 80 // Scroll to top of body
                }, 500);
            });
        },
        changeMethod: function changeMethod(method) {
            this.paymentMethod = method;
        },
        initBookingState: function initBookingState() {
            // let initRooms = this.rooms.reduce((reducer, room) => ({...reducer, [room]: 0}), {});
            var paxs = [(0, _extends3.default)({}, defaultPax)];
            this.booking.number_of_pax = '';
            var _booking = this.booking,
                product = _booking.product,
                newBooking = (0, _objectWithoutProperties3.default)(_booking, ['product']);

            newBooking.passengers = paxs;
            newBooking.number_of_pax = '';
            newBooking.departure_city = '';
            return newBooking;
            // rooms: initRooms,
        },
        initPaypalInstance: function initPaypalInstance() {
            var _this16 = this;

            braintree.client.create({
                authorization: this.paypalClientToken
            }, function (clientErr, clientInstance) {
                // Create PayPal component
                braintree.paypal.create({
                    client: clientInstance
                }, function (err, paypalInstance) {
                    _this16.globalPaypalInstance = paypalInstance;
                });
            });
        },
        initStripeInstance: function initStripeInstance() {
            this.clearCardStatus();
            this.stripeInstance = Stripe(this.stripePublishableKey);
            var elements = this.stripeInstance.elements();
            //    const card = elements.create('card', {style: style});

            this.cardNo = elements.create('cardNumber', {
                'placeholder': 'xxxx xxxx xxxx xxxx',
                style: stripeInputStyle
            });
            this.cvc = elements.create('cardCvc', {
                'placeholder': 'xxx',
                style: stripeInputStyle
            });
            this.exp = elements.create('cardExpiry', {
                'placeholder': 'MM/YY',
                style: stripeInputStyle
            });
        },
        mountCardElements: function mountCardElements() {
            //Card No
            this.cardNo.mount('#card-no');
            // CVC
            this.cvc.mount('#card-cvc');
            // Card expiry
            this.exp.mount('#card-exp');
            //                card.mount('#card-element');
            // Handle real-time validation errors from the card Element.
            this.cardNo.addEventListener('change', function (event) {
                var displayError = document.getElementById('card-no-errors');
                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });

            this.cvc.addEventListener('change', function (event) {
                var displayError = document.getElementById('card-cvc-errors');
                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });

            this.exp.addEventListener('change', function (event) {
                var displayError = document.getElementById('card-exp-errors');
                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });
        },
        clearCardStatus: function clearCardStatus() {

            this.cardNo ? this.cardNo.clear() : '';
            this.cvc ? this.cvc.clear() : '';
            this.exp ? this.exp.clear() : '';
            this.cardName = '';
        },
        tabFieldsCollection: function tabFieldsCollection() {
            return (0, _keys2.default)(this.tabs).reduce(function (acc, tab) {
                var collection = [];
                $('#tab-' + tab).find(':input.required').each(function () {
                    collection.push($(this).attr('name'));
                });

                acc[tab] = collection;
                return acc;
            }, {});
        },
        displaySurcharge: function displaySurcharge(val) {
            if (typeof val !== 'null' && typeof val !== 'null' && val != 0) {
                return '+ ( $ ' + Number(val).toFixed(2) + ')';
            } else return '';
        },
        getMomentObject: function getMomentObject(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.dateFormats.yearToDay;

            return moment(date, format);
        },
        endDate: function endDate(date) {
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.dateFormats.yearToDay;

            return moment(date, format).add(length - 1, 'd');
        },
        formattedDate: function formattedDate(moment) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.dateFormats.yearToDay;

            return moment.format(format);
        },
        initPlugins: function initPlugins() {
            var _this17 = this;

            autosize($('textarea'));
            $('#travelDatePicker').datepicker({
                // format: "dd/mm/yyyy",
                startDate: this.startDate,
                beforeShowDay: function beforeShowDay(date) {
                    var mappedDate = _this17.validDates.find(function (d) {
                        return moment(d.departure_date).isSame(date);
                    });
                    var output = { enabled: Boolean(mappedDate) };
                    var surcharge = _this17.object_get(mappedDate, 'surcharge');
                    if (surcharge > 0) {
                        output.tooltip = '+ $ ' + Number(surcharge).toFixed(2);
                    }
                    return output;
                },
                templates: {
                    leftArrow: '<i class="fas fa-angle-left fa-lg btn-control fa-border color-ddd"></i>',
                    rightArrow: '<i class="fas fa-angle-right fa-lg btn-control fa-border color-ddd"></i>'
                }
            }).on('changeDate', function (e) {
                _this17.reloadProductExtensionWithDate(e.date);
            });
        },
        reversedKeyValDict: function reversedKeyValDict(data) {
            return (0, _keys2.default)(data).reduce(function (obj, key) {
                obj[data[key]] = key;
                return obj;
            }, {});
        },
        notConfirmUserIdentity: function notConfirmUserIdentity() {
            return (0, _typeof3.default)(this.user) === 'object' && this.user.hasOwnProperty('confirmedIdentity') && this.user.confirmedIdentity === false;
        },
        showOverlay: function showOverlay() {
            this.sending = true;
            $("body").addClass("loading");
        },
        hideOverlay: function hideOverlay() {
            this.sending = false;
            $("body").removeClass("loading");
        },
        checkExtension: function checkExtension(key, value) {
            if (this[key] === value) {
                this[key] = '';
            } else {
                this[key] = value;
            }
        },
        reloadProductExtensionWithDate: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(eDate) {
                var date, responseJson, extensions;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!eDate) {
                                    _context2.next = 18;
                                    break;
                                }

                                date = moment(eDate).format(this.dateFormats.yearToDay);

                                this.booking.departure_date = date;
                                this.postExtensionId = '';
                                this.preExtensionId = '';
                                this.updatingExtensions = true;
                                _context2.prev = 6;
                                _context2.next = 9;
                                return this.findProductExtensions(date);

                            case 9:
                                responseJson = _context2.sent;

                                if (responseJson['success']) {
                                    extensions = responseJson.content;

                                    this.extensions = extensions;
                                }
                                _context2.next = 16;
                                break;

                            case 13:
                                _context2.prev = 13;
                                _context2.t0 = _context2['catch'](6);

                                console.log(_context2.t0);

                            case 16:
                                this.updatingExtensions = false;
                                this.showCalendar = false;

                            case 18:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[6, 13]]);
            }));

            function reloadProductExtensionWithDate(_x5) {
                return _ref2.apply(this, arguments);
            }

            return reloadProductExtensionWithDate;
        }(),
        findProductExtensions: function findProductExtensions(travelDate) {
            var id = this.product.id,
                length = this.product.length,
                departure_date = travelDate,
                pre_overnight = this.product.pre_overnight,
                post_overnight = this.product.post_overnight;

            return $.get('/product-extensions', {
                id: id, length: length,
                departure_date: departure_date,
                pre_overnight: pre_overnight,
                post_overnight: post_overnight
            });
        },
        extensionProducts: function extensionProducts(type) {
            var _this18 = this;

            if (Array.isArray(this.extensions)) {
                return this.extensions.reduce(function (carry, ext) {
                    var extType = _this18.object_get(ext, 'pivot.type'),
                        dateMoment = moment(_this18.booking.departure_date);

                    var productDate = ext.departure_dates.find(function (date) {
                        if (extType == _this18.extensionTypes.pre) {
                            return dateMoment.isSameOrAfter(date.departure_date);
                        } else {
                            return dateMoment.isSameOrBefore(date.departure_date);
                        }
                    });
                    var bool = extType == type && dateMoment.isSame(_this18.object_get(ext, 'pivot.departure_date'));
                    if (bool) {
                        if (productDate) carry.push((0, _extends3.default)({}, ext, { seasonalSurcharge: productDate.surcharge }));else {
                            carry.push((0, _extends3.default)({}, ext));
                        }
                    }

                    return carry;
                }, []);
            }
            return [];
        },
        returnProduct: function returnProduct(id) {
            var _this19 = this;

            $('#extModal').modal('show');
            $.get('/api/op_product/get', { id: id }).then(function (data) {
                if (data.success) {
                    _this19.viewedProduct = data.content;
                    _this19.$nextTick(function () {
                        $('#reviewBody').slimScroll({
                            height: '580px'
                        });
                    });
                }
            });
        },

        // selectDepCity(cityId){
        //      console.log(cityId);
        // },
        submitForm: function submitForm() {
            var _this20 = this;

            if (this.shouldLogin && !this.hasLogin) {
                noty({ text: "You need to login before submit.", layout: 'center', type: 'error' });
            } else {
                this.$validator.validate().then(function () {
                    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(result) {
                        var responseJson, acctStatus;
                        return _regenerator2.default.wrap(function _callee3$(_context3) {
                            while (1) {
                                switch (_context3.prev = _context3.next) {
                                    case 0:
                                        if (!result) {
                                            _context3.next = 18;
                                            break;
                                        }

                                        _this20.showOverlay();

                                        if (!_this20.hasLogin) {
                                            _context3.next = 7;
                                            break;
                                        }

                                        _this20.showOverlay();
                                        _this20.processPayment();
                                        //                                            this.processPayPal();
                                        _context3.next = 18;
                                        break;

                                    case 7:
                                        responseJson = void 0;
                                        _context3.prev = 8;
                                        _context3.next = 11;
                                        return _this20.getAcctStatus();

                                    case 11:
                                        responseJson = _context3.sent;
                                        _context3.next = 17;
                                        break;

                                    case 14:
                                        _context3.prev = 14;
                                        _context3.t0 = _context3['catch'](8);

                                        console.log(_context3.t0);

                                    case 17:
                                        if (responseJson['success']) {
                                            acctStatus = responseJson['user_status'];

                                            if (!acctStatus.found) {
                                                //                                        this.processPayPal();
                                                _this20.processPayment();
                                            } else if (acctStatus.found) {
                                                if (!acctStatus.activated) {
                                                    _this20.acctPrompt = _this20.acctPrompts.needActivate;
                                                    _this20.hideOverlay();
                                                    _this20.shouldLogin = true;
                                                    _this20.selectedTab = _this20.tabs.detail;
                                                    //only arg to check user is activated
                                                    Vue.set(_this20.user, 'confirmedIdentity', false);
                                                    _this20.sendCode();
                                                    //                                    this.preventAct = true;
                                                } else {
                                                    _this20.acctPrompt = _this20.acctPrompts.login;
                                                    _this20.selectedTab = _this20.tabs.detail;
                                                    _this20.hideOverlay();
                                                    _this20.shouldLogin = true;
                                                }
                                            }
                                        } else {
                                            noty({
                                                layout: "center",
                                                modal: "true",
                                                type: responseJson["success"] ? "success" : "error",
                                                text: responseJson["msg"],
                                                timeout: 8000
                                            });
                                        }

                                    case 18:
                                    case 'end':
                                        return _context3.stop();
                                }
                            }
                        }, _callee3, _this20, [[8, 14]]);
                    }));

                    return function (_x6) {
                        return _ref3.apply(this, arguments);
                    };
                }());
            }
        },
        processPayment: function processPayment() {
            this.hideOverlay();
            var form = $('#bookingForm');
            var curPay = 0;
            if (this.action === this.actionTypes.deposit && this.product.deposit) curPay = this.totalDepositAmt;else curPay = this.totalPaidAmt;

            window.dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': { 'step': 'product-checkout', 'option': 'creditCard' },
                        'products': [{
                            id: this.product.id,
                            name: this.product.name,
                            quantity: this.paxNum
                        }]
                    }
                }
            });

            if (this.paymentMethod === this.paymentMethods.paypal) {
                this.showOverlay();
                this.processPayPal(curPay, form);
            } else if (this.paymentMethod === this.paymentMethods.stripe) {
                this.showOverlay();
                this.processStripe(curPay, form);
            } else {
                noty({
                    layout: 'center',
                    type: 'error',
                    text: 'Please select one of the payment option to process'
                });
            }
        },
        processPayPal: function processPayPal(curPay, form) {
            var _this21 = this;

            if (!this.globalPaypalInstance) {
                noty({ text: 'waiting  for payment gateway set up', layout: 'center' });
                return this.hideOverlay();
            }
            //        var btn = $("#paypal-button").attr("disabled", "disabled");


            //                      // Tokenize here!
            this.globalPaypalInstance.tokenize({
                flow: 'checkout', // Required
                amount: curPay, // Required
                currency: 'AUD', // Required
                locale: 'en_AU',
                enableShippingAddress: false,
                shippingAddressEditable: false,
                useraction: "commit"
            }, function (tokenizeErr, payload) {
                if (tokenizeErr) {
                    var text = '';
                    // Handle tokenization errors or premature flow closure
                    switch (tokenizeErr.code) {
                        case 'PAYPAL_POPUP_OPEN_FAILED':
                            text += 'Customer blocked PayPal popup.';
                            break;
                        case 'PAYPAL_POPUP_CLOSED':
                            //                                        text += 'Customer closed PayPal popup.';
                            break;
                        case 'PAYPAL_ACCOUNT_TOKENIZATION_FAILED':
                            text += 'PayPal tokenization failed. See details:' + tokenizeErr.details;
                            break;
                        case 'PAYPAL_FLOW_FAILED':
                            text += 'Unable to initialize PayPal flow. Are your options correct?' + tokenizeErr.details;
                            break;
                        default:
                            text += 'Error! ' + tokenizeErr;
                    }
                    if (text.length > 0) {
                        noty({
                            text: text,
                            layout: 'center',
                            type: 'error'
                        });
                    }
                    _this21.hideOverlay();
                } else {
                    // Submit payload.nonce to your server
                    _this21.paypalNonce = payload.nonce;
                    _this21.$nextTick(function () {
                        form.ajaxSubmit({
                            dataType: "json",
                            success: function success(responseText, statusText) {
                                _this21.hideOverlay();
                                noty({
                                    layout: "center",
                                    modal: "true",
                                    type: responseText["success"] ? "success" : "error",
                                    text: responseText["msg"],
                                    timeout: 8000,
                                    callback: {
                                        onClose: function onClose() {
                                            if (responseText["redirect"]) {
                                                window.location.replace(responseText["redirect"]);
                                            }
                                        }
                                    }
                                });
                            },
                            error: function error(xhr, status, statusText, thisForm) {
                                _this21.hideOverlay();
                                if (xhr.status == 401) {
                                    _this21.hideOverlay();
                                } else {
                                    noty({
                                        layout: "center",
                                        modal: "true",
                                        type: "error",
                                        timeout: 3000,
                                        text: statusText
                                    });
                                }
                            }
                        });
                    });
                }
            });
        },
        processStripe: function processStripe(curPay, form) {
            var _this22 = this;

            if (this.cardName.trim() == '') {
                noty({
                    layout: "center",
                    modal: "true",
                    type: "error",
                    timeout: 3000,
                    text: 'Card holder name cannot be empty'
                });
                this.hideOverlay();
                return;
            }
            var cardData = {
                name: this.cardName
            };
            this.stripeInstance.createToken(this.cardNo, cardData).then(function (result) {
                if (result.error) {
                    // Inform the user if there was an error.
                    //                var errorElement = document.getElementById('card-errors');
                    //                errorElement.textContent = result.error.message;
                    noty({
                        layout: "center",
                        modal: "true",
                        type: "error",
                        timeout: 3000,
                        text: result.error.message
                    });
                    _this22.hideOverlay();
                } else {
                    _this22.stripeToken = result.token.id;
                    _this22.$nextTick(function () {
                        form.ajaxSubmit({
                            dataType: "json",
                            success: function success(responseText, statusText) {
                                _this22.hideOverlay();
                                noty({
                                    layout: "center",
                                    modal: "true",
                                    type: responseText["success"] ? "success" : "error",
                                    text: responseText["msg"],
                                    timeout: 8000,
                                    callback: {
                                        onClose: function onClose() {
                                            if (responseText["redirect"]) {
                                                window.location.replace(responseText["redirect"]);
                                            }
                                        }
                                    }
                                });
                            },
                            error: function error(xhr, status, statusText, thisForm) {
                                _this22.hideOverlay();
                                if (xhr.status == 401) {
                                    _this22.hideOverlay();
                                } else {
                                    noty({
                                        layout: "center",
                                        modal: "true",
                                        type: "error",
                                        timeout: 3000,
                                        text: statusText
                                    });
                                }
                            }
                        });
                    });
                }
            });
        },
        getAcctStatus: function getAcctStatus() {
            // return $.get('{{route('site::check_email_status')}}', {email:this.user.email});
            return $.get('/account/status', { email: this.user.email });
        },
        getProduct: function getProduct(ext, key) {
            var subKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            //object_get(ext,'departure_dates.'+ leadIndex +'.departure_date')
            var variable = this.object_get(ext, key);
            if (variable && subKey) {
                if (key === 'departure_dates') variable = this.object_get(variable, this.leadIndex + '.' + subKey);else {
                    variable = this.object_get(variable, '' + subKey);
                }
            }
            return variable;
        },
        getComputedDeposit: function getComputedDeposit(prod) {
            var isCore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            if (isCore) {
                if (this.isAgent) return prod.agent_deposit;else return prod.deposit;
            } else {
                if (this.isAgent) return prod.agent_land_only_deposit;else return prod.land_only_deposit;
            }
        },
        getStringInvoiceDescription: function getStringInvoiceDescription(ext) {
            var str = ext.name;
            var date = this.getProduct(ext, 'departure_dates', 'departure_date');
            if (date) str += ' -' + this.formattedDate(this.getMomentObject(date));

            str += ' payment: ' + ext.regular_price + ' p.p ';
            if (this.action === this.actionTypes.deposit) {
                str += '- Deposit ' + this.getComputedDeposit(ext, 0) + ' p.p' + ('= ' + (ext.regular_price - this.getComputedDeposit(ext, 0)));
            }

            return str;
        },
        getVoucherDiscount: function getVoucherDiscount(voucher) {
            var price = this.product.regular_price;
            var discount = voucher.discount;
            if (discount < 1) {
                discount = price * discount;
            }
            discount = Math.round(discount);
            // if(voucher.type == {{\App\Models\Operation\ProductPromotion::T_PASSENGER}}){
            if (voucher.type == this.promotionTypes.passenger) {
                discount = discount * this.paxNum;
            }

            return discount;
        },
        getVoucherValidation: function getVoucherValidation() {
            var code = this.appliedVoucherCode,
                user_id = this.object_get(this.user, 'id'),
                product_id = this.object_get(this.product, 'id');
            var data = { code: code, user_id: user_id, product_id: product_id };

            // return $.get('{{route('site::validate_voucher')}}',data);
            return $.get('/product/validate-voucher', data);
        },
        handleApply: function handleApply() {
            if (this.isValidatingCode == false) this.validateVoucher();
            // this.sending = true;},
        },
        validateVoucher: function () {
            var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var _this23 = this;

                var responseData;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                responseData = null;

                                this.isValidatingCode = true;

                                if (this.includedVouchers.some(function (v) {
                                    return v.code.toUpperCase() == _this23.appliedVoucherCode.toUpperCase();
                                })) {
                                    _context4.next = 15;
                                    break;
                                }

                                _context4.prev = 3;
                                _context4.next = 6;
                                return this.getVoucherValidation();

                            case 6:
                                responseData = _context4.sent;
                                _context4.next = 12;
                                break;

                            case 9:
                                _context4.prev = 9;
                                _context4.t0 = _context4['catch'](3);

                                console.log(_context4.t0);

                            case 12:
                                if (responseData['success']) {
                                    responseData['content']['code'] = responseData['content']['code'].trim();
                                    this.includedVouchers.push(responseData['content']);
                                    this.appliedVoucherCode = '';
                                } else {
                                    noty({
                                        layout: 'center',
                                        type: 'error',
                                        text: responseData['msg'],
                                        timeout: 5000
                                    });
                                }
                                _context4.next = 16;
                                break;

                            case 15:
                                noty({
                                    layout: 'center',
                                    type: 'error',
                                    text: 'You already have apply the code',
                                    timeout: 5000
                                });

                            case 16:
                                this.isValidatingCode = false;

                            case 17:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[3, 9]]);
            }));

            function validateVoucher() {
                return _ref4.apply(this, arguments);
            }

            return validateVoucher;
        }(),
        startLogInfoTimer: function startLogInfoTimer() {
            var _this24 = this;

            var fieldsMap = this.tabFieldsCollection();
            var reversedDict = this.reversedKeyValDict(this.tabs);
            var hasError = false;

            this.collectInfoTimer = setInterval((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                var validateArr, addtl;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:

                                if (Array.isArray(fieldsMap[reversedDict[_this24.tabs.detail]]) && fieldsMap[reversedDict[_this24.tabs.detail]].length > 0) {
                                    validateArr = fieldsMap[reversedDict[_this24.tabs.detail]].map(function (field) {
                                        return _this24.fields[field].valid;
                                    });

                                    hasError = validateArr.some(function (result) {
                                        return result === false;
                                    });
                                }
                                if (!hasError) {
                                    clearInterval(_this24.collectInfoTimer);
                                    addtl = null;

                                    if (_this24.booking.departure_date) {
                                        addtl = { departure_date: _this24.booking.departure_date };
                                    }

                                    _this24.postBookingIntention(addtl);
                                }

                            case 2:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this24);
            })), 5000);
        },
        postBookingIntention: function postBookingIntention() {
            var addlInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var info = {
                user: (0, _extends3.default)({}, this.user),
                product: {
                    name: this.product.name,
                    id: this.product.id
                } };
            if (addlInfo) {
                info = (0, _extends3.default)({}, info, addlInfo);
            }
            return $.post('/book/collect-info', info);
        },
        readableAgentCommission: function readableAgentCommission(rate) {
            if (rate > 1) {
                return '$' + rate;
            } else {
                return rate * 100 + '%';
            }
        }
    },
    filters: {
        pad: function pad(val) {
            var s = String(val);
            while (s.length < 2) {
                s = "0" + s;
            }
            return s;
        }
    }
});

},{"babel-runtime/core-js/object/keys":3,"babel-runtime/core-js/promise":4,"babel-runtime/helpers/asyncToGenerator":7,"babel-runtime/helpers/extends":8,"babel-runtime/helpers/objectWithoutProperties":9,"babel-runtime/helpers/toConsumableArray":10,"babel-runtime/helpers/typeof":11,"babel-runtime/regenerator":12}]},{},[109]);
